// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-big-function

import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import { SimpleSelectOptionType } from '@epicuro-next/features/landing-panel';
import {
  IDynamicBindableValue,
  IDynamicInput,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import { getIdProvider } from '../../../../utils/dynamic-items-utils';

import {
  createSquarePanelFromRecommendations,
  ids as recommendationsTemplateIds,
} from './../square-panel-from-recommendations';
import {
  ids as templateIds,
  propertyNames as templatePropertyNames,
} from './../square-panel-template';
import {
  addRequestedDeliveryDateAndQuantitiesToItemContent,
  createApiRequestPayloadPropertiesProvider,
  productsOnTheWayApiResponseTransform,
} from './products-on-the-way-helpers';
import { itemsInHeaderWrapper } from './products-on-the-way-header-container';
import { daysIntoTheFutureProvider } from './products-on-the-way-days-into-future-provider';

export const propertyNames = {
  ...templatePropertyNames,
  attributesFontSize: 'attributesFontSize',
  daysIntoThePast: 'daysIntoThePast',
  daysIntoTheFuture: 'daysIntoTheFuture',
  filterMissingImages: 'filterMissingImages',
  quantityFontSize: 'quantityFontSize',
  selectedDayRange: 'selectedDayRange',
  selectedShipTo: 'selectedShipTo',
  showOrdinalSuffix: 'showOrdinalSuffix',
};

export const ids = {
  ...templateIds,
  ...recommendationsTemplateIds,
};

type RecommendationsDataKeys = keyof ReturnType<
  typeof createSquarePanelFromRecommendations
>['recommendationsData']['data'];
const hasErrorKey: RecommendationsDataKeys = 'hasError';

export const squarePanelFromRecommendationsProductsOnTheWay =
  createSquarePanelFromRecommendationsProductsOnTheWay().styleWrapper;

export function createSquarePanelFromRecommendationsProductsOnTheWay() {
  const filterByShipToSelectId = 'filter-by-ship-to-select';

  const shipToAddressIdProvider: IDynamicBindableValue = {
    ...getIdProvider(filterByShipToSelectId, 'selectionChanged'),
    startWith: {
      value: {
        value: undefined,
      },
    },
    transform: function (option: SimpleSelectOptionType): string | undefined {
      return option.value;
    }.toString(),
  };

  const apiRequestPayloadPropertiesProvider =
    createApiRequestPayloadPropertiesProvider({
      daysIntoTheFuture: daysIntoTheFutureProvider,
      daysIntoThePast: getIdProvider(
        ids.squarePanelRoot,
        propertyNames.daysIntoThePast,
      ),
      shipToAddressId: shipToAddressIdProvider,
      filterMissingImages: getIdProvider(
        ids.squarePanelRoot,
        propertyNames.filterMissingImages,
      ),
      brandId: getIdProvider(ids.squarePanelRoot, propertyNames.brandId),
    });

  const template = createSquarePanelFromRecommendations(
    'ProductsOnTheWayTestPanel',
    {
      apiRequestPayloadPropertiesProvider,
      panelStatusEvent: {
        error: {
          ...getIdProvider('recommendations-data', hasErrorKey),
          filter: function (): boolean {
            return false; // Never trigger fallback as this is a panel with user interaction
          }.toString(),
        },
      },
    },
    productsOnTheWayApiResponseTransform(),
  );

  // This ping pong to root and simpleDayRangeSelect is needed as id providing does not work on an element of itself.
  (template.root.data as { [key: string]: IDynamicInput })[
    propertyNames.selectedDayRange
  ] = daysIntoTheFutureProvider;

  (template.root.data as { [key: string]: IDynamicInput })[
    propertyNames.selectedShipTo
  ] = shipToAddressIdProvider;

  addAdditionalArguments(
    template.root.data as { [key: string]: IDynamicInput },
  );

  template.headerContainer.children = [itemsInHeaderWrapper];

  template.root.data.seeMoreLink = '/pockets';

  addRequestedDeliveryDateAndQuantitiesToItemContent(
    template,
    propertyNames.productData,
    {
      quantityFontSize: getIdProvider(
        template.root.id,
        propertyNames.quantityFontSize,
      ),
      requestedDeliveryDateFontSize: getIdProvider(
        template.root.id,
        propertyNames.attributesFontSize,
      ),
      showOrdinalSuffix: getIdProvider(
        template.root.id,
        propertyNames.showOrdinalSuffix,
      ),
    },
  );

  template.root.data.noProductsText =
    recommendationsPanelsLocaleKeys.noProductsReturnedFromTheServerTryDifferentFilterValues;
  template.root.data.noItemsIcon = ['fas', 'truck'];

  return { ...template };
}

export function addAdditionalArguments(data: {
  [key: string]: IDynamicInput;
}): void {
  data[propertyNames.attributesFontSize] = data?.fontSize ?? '1.2rem';
  data[propertyNames.daysIntoThePast] = 7;
  data[propertyNames.filterMissingImages] = true;
  data[propertyNames.quantityFontSize] = '2rem';
  data[propertyNames.showOrdinalSuffix] = true;
}
